import { SET_ITEMS, SET_ERROR, REMOVE_BY_ID, SET_USAGE, ADD_ITEM, SET_ITEM, TOGGLE_GTIN } from '../mutation-types'

import Vue from 'vue'
import axios from 'axios'

import { add, remove } from '@/components/SelectProduct'

const state = {
    data: [],
    meta: null,
    usage: {},
    error: null,

    gtinIsVisible: false,
}

const getters = {
    data: state => state.data,
    meta: state => state.meta,
    filterbyId: state => id => state.data.find(item => item.id === id),
    gtinIsVisible: state => state.gtinIsVisible,

    dataWithNetPrice: state => {
        return state.data.map(item => {
            let netPirce = 0

            for (let i = 0; i < item.components.length; i++) {
                if (item.components[i].net_price === null) {
                    netPirce = 0
                    break
                }

                netPirce += item.components[i].volume * item.components[i].net_price
            }

            if (netPirce) {
                netPirce = Math.round(netPirce * 100) / 100
            }

            return { ...item, net_price: netPirce }
        })
    }
}

const mutations = {
    [SET_ITEMS](state, { data, meta }) {
        state.data = data
        state.meta = meta
    },

    [SET_ITEM](state, item) {
        const id = item.id
        const index = state.data.findIndex(item => item.id === id)

        if (index !== -1) {
            Vue.set(state.data, index, item)
        }

        remove(id)
        add(item)
    },

    [SET_USAGE](state, { data }) {
        state.usage = data
    },

    [SET_ERROR](state, error = null) {
        state.error = error
    },

    [REMOVE_BY_ID](state, id) {
        const index = state.data.findIndex(item => item.id === id)

        if (index !== -1) {
            state.data.splice(index, 1)
        }

        remove(id)
    },

    [ADD_ITEM](state, data) {
        state.data.unshift(data)
        add(data)
    },

    [TOGGLE_GTIN](state, value) {
        state.gtinIsVisible = value
    }
}

const actions = {
    async fetchAll({ commit }, params = {}) {
        try {
            let response = await axios.get('api/products', { params })
            commit(SET_ITEMS, response.data)
        } catch (error) {
            return false
        }

        return true
    },

    async fetchById({ getters }, id) {
        const product = getters.filterbyId(id)

        if (product) {
            return product
        }

        try {
            const response = await axios.get(`api/products/${id}`)

            return response.data
        } catch (error) {
            return null
        }
    },

    async store({ commit }, { id = null, ...attributes }) {
        try {
            if (id) {
                const response = await axios.put(`api/products/${id}`, attributes)
                commit(SET_ITEM, response.data)
            } else {
                const response = await axios.post('api/products', attributes)
                commit(ADD_ITEM, response.data)
            }
        } catch (error) {
            if (error.response.status === 422) {
                commit(SET_ERROR, error.response.data || {})
            }

            return false
        }

        return true
    },

    async remove({ commit }, id) {
        try {
            await axios.delete(`api/products/${id}`)
            commit(REMOVE_BY_ID, id)
        } catch (error) {
            return false
        }

        return true
    },

    async getUsage({ commit }, id) {
        try {
            let response = await axios.get(`api/products/${id}/usage`)
            commit(SET_USAGE, response)
        } catch (error) {
            return false
        }

        return true
    },

    toggleGtin({ commit }, value) {
        commit(TOGGLE_GTIN, value)
    }
}

export default {
    namespaced: true,

    state,
    getters,
    mutations,
    actions
}
